import { defineMessages } from '@jutro/locale';

export default defineMessages({
    title: {
        id: 'ml.gateway.views.account-detail.avaiableDocumentBilling.Available Documents',
        defaultMessage: 'Available Documents'
    },
    subtitle1: {
        id: 'ml.gateway.views.account-detail.avaiableDocumentBilling.All the required documents must be signed in order to proceed',
        defaultMessage: 'All the required documents must be signed in order to proceed'
    },
    subtitle2: {
        id: 'ml.gateway.views.account-detail.avaiableDocumentBilling.The following documents must be retained for your records.',
        defaultMessage: 'The following documents must be retained for your records.'
    },
    documentHeader: {
        id: 'ml.gateway.views.account-detail.avaiableDocumentBilling.Documents',
        defaultMessage: 'DOCUMENTS'
    },
    signatureTypeHeader: {
        id: 'ml.gateway.views.account-detail.avaiableDocumentBilling.Signature Type',
        defaultMessage: 'SIGNATURE TYPE'
    },
    dateSignedHeader: {
        id: 'ml.gateway.views.account-detail.avaiableDocumentBilling.Date Signed',
        defaultMessage: 'DATE SIGNED'
    },
    actionsHeader: {
        id: 'ml.gateway.views.account-detail.avaiableDocumentBilling.Actions',
        defaultMessage: 'ACTIONS'
    },
    nextDescription: {
        id: 'ml.gateway.views.account-detail.avaiableDocumentBilling.Well process your payment next',
        defaultMessage: 'We\'ll process your payment next'
    },
    documentRetention: {
        id: 'ml.gateway.views.account-detail.avaiableDocumentBilling.Document Retention',
        defaultMessage: 'Document Retention'
    },
    view: {
        id: 'ml.gateway.views.account-detail.avaiableDocumentBilling.View',
        defaultMessage: 'View'
    },
    viewEnglish: {
        id: 'ml.gateway.views.account-detail.avaiableDocumentBilling.View English',
        defaultMessage: 'View English'
    },
    viewSpanish: {
        id: 'ml.gateway.views.account-detail.avaiableDocumentBilling.View Spanish',
        defaultMessage: 'View Spanish'
    },
    continue: {
        id: 'ml.gateway.views.account-detail.avaiableDocumentBilling.Continue',
        defaultMessage: 'CONTINUE'
    },
    processingPayment: {
        id: 'ml.gateway.views.account-detail.avaiableDocumentBilling.Processing Payment',
        defaultMessage: 'Processing Payment'
    },
})